import { TableChangeSource } from '../TableTypes';

export const isTableCellMetaChangeSource = (source?: string): boolean =>
    source?.startsWith(`${TableChangeSource.CELL_META_PREFIX}.`) ?? false;
